import './schedule-card.scss';
